module.exports = __webpack_public_path__ + "1f9fb821535b41a21ceb40fa5044a47a.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/mixmotos.png
// module id = 612
// module chunks = 0